import React from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import Icon from 'Views/Components/_HumanWritten/Icon/Icon';

export interface BreadcrumbItem {
	label: string;
	to?: string;
}

interface BreadcrumbsProps {
	items: BreadcrumbItem[];
	className?: string;
}

export const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ items, className }) => {
	return (
		<nav aria-label="Breadcrumb" className={classNames('flex py-1', className)}>
			<ol className="flex items-center text-sm">
				{items.map((item, index) => {
					const isLast = index === items.length - 1;

					return (
						<li key={item.to ?? item.label} className="flex items-center">
							{index > 0 && (
								<Icon
									name="chevron_right"
									useMaterialIcons
									classname="mx-2 text-gray-400 !text-[18px]"
								/>
							)}
							{isLast || !item.to ? (
								<p className="!mb-0 !text-sm">{item.label}</p>
							) : (
								<Link to={item.to} className="hide-underline !text-sm">
									{item.label}
								</Link>
							)}
						</li>
					);
				})}
			</ol>
		</nav>
	);
};
